import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import { useSelector, shallowEqual } from 'react-redux';
import {
  COLUMN_HIGHLIGHT_CLASS,
  EMPTY_DATA_MARKER,
} from '../../../../common/engine/utilities/constants';
import { financialValue } from '../../../../common/services/textService';
import { getProjectFinancials } from '../../../project/projectSlice';

const FinancialValue = ({
  text,
  emptyDataMarker = EMPTY_DATA_MARKER,
  showColumnHighlight,
}) => {
  const cellClassNames = classnames('financial-value', {
    [COLUMN_HIGHLIGHT_CLASS]: showColumnHighlight,
  });

  const financialsDisplaySettings = useSelector(
    getProjectFinancials,
    shallowEqual
  );

  const { financialsDecimalCount, financialsMagnitude } =
    financialsDisplaySettings;
  return (
    <td role="cell" className={cellClassNames} data-testid="financial-value">
      <span aria-hidden="true" data-testid="visual-content">
        {text === ''
          ? emptyDataMarker
          : financialValue(text, {
              decimalCount: financialsDecimalCount,
              financialsMagnitude,
              formatForScreenReader: false,
              emptyDataMarker,
            })}
      </span>
      <span className="visually-hidden" data-testid="screen-reader-content">
        {financialValue(text, {
          decimalCount: financialsDecimalCount,
          financialsMagnitude,
          formatForScreenReader: true,
          emptyDataMarker,
        })}
      </span>
    </td>
  );
};

FinancialValue.propTypes = {
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.symbol,
  ]),
  emptyDataMarker: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  showColumnHighlight: PropTypes.bool,
};

FinancialValue.defaultProps = {
  text: '',
  emptyDataMarker: '-',
  showColumnHighlight: false,
};

export default FinancialValue;
